import { Component } from '@angular/core';

@Component({
  selector: 'app-incoming-referrals',
  templateUrl: './incoming-referrals.component.html',
  styleUrls: ['./incoming-referrals.component.css'],
  standalone: false,
})
export class IncomingReferralsComponent {}
